ACC.header = {
  $loginnoerror: $('.ph-hamburger__loginnoerror'),
  $loginerror: $('.ph-hamburger-loginerror'),
  $searchinput: $('.ph-headerparent__searchinput'),
  $primarysearchicon: $('.ph-headerparent__primarysearchicon'),
  searchbordercolor: 'ph-headerparent__searchbordercolor',
  displaymdblock: 'ph-d-md-block',
  // $notloggedintooltip : $('.ph-notloggedin-tooltip'),
  colorchange: 'ph-colorchange',
  $searchlabel: $('.ph-searchlabel'),
  // Displaymdblock: 'ph-d-md-block',
  $hamburgermobilee: $('.ph-headerparent__hamburgermobile'),
  $headerlogintabmobile: $('.ph-header_login_tab_mobile'),
  $headercountrysearchmobile: $('.ph-headerparent__searchordermobile'),
  notloggedintooltip: '.ph-notloggedin-tooltip',
  loggedintooltip: '.ph-loggedin-tooltip',
  flyoutMainClass: '.ph-flyout_main',
  $loginRegRedirect: $('.ph-loginRedirectToggle'),
  loginRedirectUrlattr: 'data-loginredirecturl',
  oneidLoginUrlAnchor: '#oneidLoginUrlAnchor',
  loginActionPopupDiv: '.ph-loginaction-container',
  isSearchBarNotFocused: true,
  primarysearchwrapperClass: '.ph-headerparent__primarysearchwrapper',
  searchDesktopId: '#search_desktop',
  searcIconParentClass: '.ph-headerparent__primarysearchiconparent',
  headerStoreTypeTextClass: '.ph-headerparent__primaryheadertext',
  hidestorename: 'ph-hidestorename',

  headerContentCategoryStyle: function() {
    if ($('.ph-headerparent__categorystyle').text() !== '') {
      var categoryCode = document.querySelector('.ph-headerparent__categorycode').textContent,
          categoryName = document.querySelector('.ph-headerparent__categorystyle').textContent;

      $('.ph-subnavigation .ph-headerparent__naviparent').each(function() {
        var $navAddSelectedVal = $(this).find('span a');

        if ($navAddSelectedVal.text() === categoryName) {
          $(this).addClass('ph-navactive ph-navselected');
        }

        /* eslint-disable  no-undefined */
        if ($navAddSelectedVal.attr('href') !== undefined && $navAddSelectedVal.attr('href').indexOf(categoryCode) >= 0) {
          /* eslint-enable  no-undefined */
          $(this).addClass('ph-navactive ph-navselected');
        }
      });

      $('.ph-headerparent__navimobileparent').each(function() {
        var $navAddSelected = $(this).find('li a');

        if ($navAddSelected.text() === categoryName) {
          $(this).addClass('ph-navactivemobile ph-navselected');
        }

        /* eslint-disable  no-undefined */
        if ($navAddSelected.attr('href') !== undefined && $navAddSelected.attr('href').indexOf(categoryCode) >= 0) {
        /* eslint-enable  no-undefined */
          $(this).addClass('ph-navactivemobile ph-navselected');
        }
      });
    }
  },
  productSearchTagging: function() {
    $('.ph-headerparent__searchinput,.ph-searchparent__input').on('click', function() {
      window.gaclkFn.gaButtonClicks({
        elementClass: '',
        triggerType: 'search',
        sectionValue: 'product_search_inputbox',
        linkValue: ''
      });
    });
    $('.ph-login_login').on('click', function() {
      window.gaclkFn.gaButtonClicks({
        elementClass: '',
        triggerType: 'link',
        sectionValue: 'login_login',
        linkValue: ''
      });
    });
    $('.ph-notloggedin_register').on('click', function() {
      window.gaclkFn.gaButtonClicks({
        elementClass: '',
        triggerType: 'link',
        sectionValue: 'login_register',
        linkValue: ''
      });
    });
  },
  headerContent: function() {
    ACC.header.headerContentCategoryStyle();
    $('.ph-subnavigation .ph-headerparent__naviparent').each(function() {
      if ($(this).find('.ph-headerparent__navichild').is(':empty')) {
        $(this).addClass('ph-hidden');
      }
    });

    $('.ph-headerparent__navichild a').hover(function() {
      if (!$(this).parents('.ph-headerparent__naviparent').hasClass('ph-navselected')) {
        $(this).parents('.ph-headerparent__naviparent').addClass('ph-navactive');
      }
    },
    function() {
      if (!$(this).parents('.ph-headerparent__naviparent').hasClass('ph-navselected')) {
        $(this).parents('.ph-headerparent__naviparent').removeClass('ph-navactive');
      }
    });
    $(document).on('click', '.ph-flyout_loginnow', function() {
      if (ACC.header.$loginRegRedirect.length > 0 && $(ACC.header.oneidLoginUrlAnchor)[0]) {
        $(ACC.header.oneidLoginUrlAnchor)[0].click();
      } else {
        var loginPopupOpen = $(ACC.header.notloggedintooltip).hasClass(ACC.header.displaymdblock);

        if (!loginPopupOpen) {
          $(ACC.header.notloggedintooltip).addClass(ACC.header.displaymdblock);
          ACC.header.openPopupClicked(ACC.header.notloggedintooltip);
        }
      }
    });
  },
  openPopupClicked: function(popupElement) {
    if ($(popupElement).hasClass('ph-d-md-block')) {
      $(popupElement).addClass('ph-opened');
    } else {
      $(popupElement).removeClass('ph-opened');
    }
  },
  headerOpenMenuPopup: function() {
    var loginPopupHideTimer = null;

    function scheduleLoginPopupHide() {
      clearTimeout(loginPopupHideTimer);
      loginPopupHideTimer = setTimeout(function() {
        /* The b2b unit selectBox menu is appended to <body> and positioned from the control.
           Keep the popup visible while that menu is open, otherwise the control loses its layout box. */
        if ($('.selectBox-menuShowing').length > 0 || $('.selectBox-dropdown-menu:hover').length > 0) {
          return;
        }

        if ($('.ph-headerparent__hamburgermobile:visible').length === 0 &&
            $('.ph-notloggedin-tooltip:hover, .ph-position-tooltip:hover').length === 0 &&
            !$(document.activeElement).is('input, textarea, select')) {
          $(ACC.header.notloggedintooltip).removeClass(ACC.header.displaymdblock);
        }
      }, 120);
    }

    $(document).on('mouseenter', '.ph-position-tooltip > .ph-notloggedIn, .ph-notloggedin-tooltip', function() {
      clearTimeout(loginPopupHideTimer);

      if ($('.ph-headerparent__hamburgermobile:visible').length === 0) {
        $(ACC.header.notloggedintooltip).addClass(ACC.header.displaymdblock);
      }
    });

    $(document).on('mouseleave', '.ph-position-tooltip > .ph-notloggedIn, .ph-notloggedin-tooltip', function(event) {
      // Moving into the body-appended selectBox list must not hide the popup.
      if ($(event.relatedTarget).closest('.selectBox-dropdown-menu').length > 0) {
        return;
      }

      scheduleLoginPopupHide();
    });

    // When the pointer leaves the open selectBox list, re-check whether the popup should close.
    $(document).on('mouseleave', '.selectBox-dropdown-menu', function(event) {
      if ($(event.relatedTarget).closest('.ph-notloggedin-tooltip, .ph-position-tooltip').length === 0) {
        scheduleLoginPopupHide();
      }
    });

    $('.ph-headerparent__searchiconparentmobile').on('click', function() {
      if ($('.ph-searchactive').length === 0) {
        ACC.header.$hamburgermobilee.toggleClass('ph-hamburgeractive');
        $('.ph-hamburger__wrapper').removeClass('ph-d-none hidden ph-d-md-none');
        ACC.header.$loginnoerror.removeClass('ph-d-none');
        ACC.header.$searchinput.removeClass('ph-searchparent__input');
        ACC.header.$primarysearchicon.addClass(ACC.header.colorchange);
        ACC.header.$searchinput.val('');
        $('html').addClass('ph-overflowy__hide');
        $('.ph-loginsection').addClass('hidden');
        $('.ph-headerparent__searchordermobile').addClass('hidden');
        $('.ph-hamburger_menu_fields').addClass('hidden');
        $('.ph-sideShortcuts').addClass('hidden');
      }
    });

    $(document).on('click', '.ph-loggedIn', function() {
      $('.ph-loggedin-tooltip').toggleClass('ph-d-md-block');
      ACC.header.openPopupClicked(ACC.header.loggedintooltip);
    });
    $(document).on('mouseover', '.ph-loggedin-tooltip,.ph-loggedIn', function() {
      if ($('.ph-headerparent__hamburgermobile:visible').length === 0) {
        $(ACC.header.loggedintooltip).addClass('ph-d-md-block');
      }
    });
    $(document).on('mouseout', '.ph-loggedin-tooltip,.ph-loggedIn', function() {
      if ($('.ph-headerparent__hamburgermobile:visible').length === 0) {
        $(ACC.header.loggedintooltip).removeClass('ph-d-md-block');
      }
    });

    $(document).on('mouseover', '.ph-loginaction-popup,.ph-ssoEnabled', function() {
      if ($(ACC.header.notloggedintooltip).hasClass('ph-opened') === false &&
       $('.ph-headerparent__hamburgermobile:visible').length === 0) {
        $('.ph-loginaction-popup').addClass('ph-d-md-block');
      }
    });
    $(document).on('mouseout', '.ph-loginaction-popup,.ph-ssoEnabled', function() {
      if ($('.ph-headerparent__hamburgermobile:visible').length === 0) {
        $('.ph-loginaction-popup').removeClass('ph-d-md-block');
      }
    });


    $(document).on('click', '.ph-notloggedIn', function() {
      ACC.header.slowScrollToTop();

      if ($(window).width() < 700) {
        ACC.header.$hamburgermobilee.trigger('click');
      } else if (ACC.header.$loginRegRedirect.length > 0 && $(ACC.header.oneidLoginUrlAnchor)[0]) {
        $(ACC.header.oneidLoginUrlAnchor)[0].click();
      } else {
        $(ACC.header.notloggedintooltip).toggleClass(ACC.header.displaymdblock);
      }

      ACC.header.openPopupClicked(ACC.header.notloggedintooltip);
    });


    $(document).on('click', '.ph-searchmobilecross', function() {
      $('.ph-headerparent__searchwrappermobile').toggleClass('hidden');
    });
    $(document).on('click', '.ph-searchparent__input', function() {
      ACC.header.$primarysearchicon.addClass(ACC.header.colorchange);
      $('.ph-searchparent__input').addClass('ph-colorchangeinput');
      $('.ph-searchboxbottom-onfocus').addClass('ph-d-lg-block');
      $(ACC.header.headerStoreTypeTextClass).addClass(ACC.header.hidestorename);
    });
    $(document).mouseup(function(e) {
      if ($(e.target).closest(ACC.header.primarysearchwrapperClass).length === 0) {
        $('.ph-searchparent__input').removeClass('ph-colorchangeinput');
        ACC.header.$searchlabel.removeClass('hidden');
        $('.ph-searchboxbottom-onfocus').removeClass('ph-d-lg-block');
        $(ACC.header.headerStoreTypeTextClass).removeClass(ACC.header.hidestorename);
        $('.ph-searchparent__input').val('');
        $('label[for=search_desktop]').addClass('ph-searchlabel_offfocus');
        $(ACC.header.searchDesktopId).removeClass('ph-searchinput_onfocus');
        $(ACC.header.searchDesktopId).addClass('ph-searchinput_offfocus');
        ACC.header.isSearchBarNotFocused = true;
      }
    });

    function searchpress(obj) {
      $('.ph-headerparent__primarysearchcross').addClass('ph-opacity');
      $(obj).addClass(ACC.header.searchbordercolor);
    }

    $(document).on('keypress', '.ph-searchparent__input', function() {
      ACC.header.$searchlabel.addClass('hidden');
      searchpress(this);
    });
    $(document).on('keypress keydown', '.ph-headerparent__searchinput', function() {
      searchpress(this);
    });
    $(document).on('mousedown', '.ph-headerparent__primarysearchcross', function() {
      $('.ph-searchparent__input').val('');
      ACC.header.$searchinput.val('');
      $(this).removeClass('ph-opacity');

      return false;
    });
    $('body').append('<div id="ph-searchbox_overlay"></div>');
  },
  headerCountrySelectorMobileTab: function() {
    ACC.header.$headercountrysearchmobile.on('click', function() {
      ACC.header.$hamburgermobilee.toggleClass('ph-searchactive');
      ACC.header.$loginnoerror.removeClass('hidden ph-d-md-none ph-d-none');
      ACC.header.$loginerror.removeClass('ph-d-none ph-d-md-none');
      ACC.header.$searchinput.addClass('ph-searchparent__input');
      ACC.header.$primarysearchicon.removeClass(ACC.header.colorchange);
      $('.ph-headerparent__primarysearchcross').removeClass('ph-opacity');
      ACC.header.$searchinput.val('');
      ACC.header.$searchinput.removeClass(ACC.header.searchbordercolor);
      $('html').addClass('ph-overflowy__hide');
      $('.ph-loginsection').addClass('hidden');
      $('.ph-headerparent__searchordermobile').addClass('hidden');
      $('.ph-hamburger_menu_fields').addClass('hidden');
    });

    $('.ph-header__hamburgerclose').on('click', function() {
      ACC.header.$loginnoerror.addClass('hidden ph-d-md-none ph-d-none');
      ACC.header.$loginerror.removeClass('ph-d-block');
      ACC.header.$loginerror.addClass('ph-d-none');
      ACC.header.$hamburgermobilee.removeClass('ph-hamburgeractive ph-searchactive');
      $('html').removeClass('ph-overflowy__hide');
      $('.ph-headerparent__searchordermobile').removeClass('hidden');
      $('.ph-loginsection').removeClass('hidden');
      $('.ph-hamburger_menu_fields').removeClass('hidden');
    });
    ACC.header.headerOpenMenuPopup();
  },

  headerLoginMobileTab: function() {
    ACC.header.$headerlogintabmobile.on('click', function() {
      ACC.header.$hamburgermobilee.toggleClass('ph-searchactive');
      ACC.header.$loginnoerror.removeClass('hidden ph-d-md-none ph-d-none');
      ACC.header.$loginerror.removeClass('ph-d-none ph-d-md-none');
      ACC.header.$searchinput.addClass('ph-searchparent__input');
      ACC.header.$primarysearchicon.removeClass(ACC.header.colorchange);
      $('.ph-headerparent__primarysearchcross').removeClass('ph-opacity');
      ACC.header.$searchinput.val('');
      ACC.header.$searchinput.removeClass(ACC.header.searchbordercolor);
      $('html').addClass('ph-overflowy__hide');

      $('.ph-searchparent').addClass('hidden');
      $('.ph-sideShortcuts').addClass('hidden');
      $('.ph-headerparent__searchordermobile').addClass('hidden');
      $('.ph-hamburger_menu_fields').addClass('hidden');
    });

    $('.ph-header__hamburgerclose').on('click', function() {
      ACC.header.$loginnoerror.addClass('hidden ph-d-md-none ph-d-none');
      ACC.header.$loginerror.removeClass('ph-d-block');
      ACC.header.$loginerror.addClass('ph-d-none');
      ACC.header.$hamburgermobilee.removeClass('ph-hamburgeractive ph-searchactive');
      $('html').removeClass('ph-overflowy__hide');
      $('.ph-searchparent').removeClass('hidden');
      $('.ph-sideShortcuts').removeClass('hidden');
      $('.ph-headerparent__searchordermobile').removeClass('hidden');
      $('.ph-hamburger_menu_fields').removeClass('hidden');
    });
    ACC.header.headerOpenMenuPopup();
  },
  headerContentMobile: function() {
    ACC.header.$hamburgermobilee.on('click', function() {
      if ($('.ph-hamburgeractive').length === 0) {
        ACC.header.$hamburgermobilee.toggleClass('ph-searchactive');
        ACC.header.$loginnoerror.removeClass('hidden ph-d-md-none ph-d-none');
        ACC.header.$loginerror.removeClass('ph-d-none ph-d-md-none');
        ACC.header.$searchinput.addClass('ph-searchparent__input');
        ACC.header.$primarysearchicon.removeClass(ACC.header.colorchange);
        $('.ph-headerparent__primarysearchcross').removeClass('ph-opacity');
        ACC.header.$searchinput.val('');
        ACC.header.$searchinput.removeClass(ACC.header.searchbordercolor);
        $('html').addClass('ph-overflowy__hide');
        $('.ph-loginsection').addClass('hidden');
        $('.ph-sideShortcuts').addClass('hidden');
      }
    });

    $('.ph-header__hamburgerclose').on('click', function() {
      ACC.header.$loginnoerror.addClass('hidden ph-d-md-none ph-d-none');
      ACC.header.$loginerror.removeClass('ph-d-block');
      ACC.header.$loginerror.addClass('ph-d-none');
      ACC.header.$hamburgermobilee.removeClass('ph-hamburgeractive ph-searchactive');
      $('html').removeClass('ph-overflowy__hide');
      $('.ph-loginsection').removeClass('hidden');
      $('.ph-sideShortcuts').removeClass('hidden');
    });
    ACC.header.headerOpenMenuPopup();
  },
  inputValidations: function() {
    $(document).on('input', '.ph-searchparent__input', function() {
      $('.ph-searchlabel').addClass('hidden');
    });
    $(document).on('keypress', '.ph-loginemailinput', function() {
      $('.ph-logincross').addClass('ph-opacity');
      $(this).addClass(ACC.header.searchbordercolor);
    });
    $(document).on('mousedown', '.ph-logincross', function() {
      $('.ph-loginemailinput').val('');
      $(this).removeClass('ph-opacity');

      return false;
    });
    $(ACC.header.searcIconParentClass).on('click', function(e) {
      var formElem = this.closest('form'),
          inputElem = $(formElem).find('.ph-searchparent__input'),
          inputValue = '';

      $(ACC.header.searchDesktopId).trigger('click');
      $(ACC.header.headerStoreTypeTextClass).addClass(ACC.header.hidestorename);

      $(ACC.header.searchDesktopId).removeClass('ph-searchinput_offfocus');
      $(ACC.header.searchDesktopId).addClass('ph-searchinput_onfocus');
      $('label[for=search_desktop]').removeClass('ph-searchlabel_offfocus');
      $(ACC.header.searchDesktopId).siblings(ACC.header.searcIconParentClass).addClass('ph-searchIcon_onfocus');
      ACC.header.isSearchBarNotFocused = false;

      if (inputElem.length > 0) {
        inputValue = $.trim(inputElem[0].value);
      } else {
        inputValue = $.trim($(formElem).find('.ph-headerparent__searchinput')[0].value);
      }

      window.gaclkFn.gaButtonClicks({
        elementClass: '',
        triggerType: 'search',
        sectionValue: 'submit_magnifier_icon',
        linkValue: ''
      });

      if (inputValue.length === 0) {
        e.preventDefault();
        $(ACC.header.searchDesktopId).focus();

        return false;
      }

      return true;
    });
    $(ACC.header.searchDesktopId).parent('form').find('button.ph-productsearchBtn').attr('type', 'submit');
    $('#search_mobile').parent('form').find('button.ph-productsearchBtn').attr('type', 'submit');
  },
  docEvents: function() {
    $(document).on('click', '#ph-login_form', function(event) {
      event.stopPropagation();
    });

    $(document).on('click', '.ph-header__tooltipclose', function() {
      $('.ph-loggedin-tooltip').addClass('ph-hidden');
      $('.ph-notloggedin-tooltip,.ph-loggedin-tooltip,.ph-loginaction-container').removeClass('ph-opened ph-d-md-block');
    });

    $(document).on('click', '.ph-homepage__member--login', function() {
      ACC.header.slowScrollToTop();

      if ($(window).width() < 700) {
        ACC.header.$hamburgermobilee.trigger('click');
      } else if (ACC.header.$loginRegRedirect.length > 0 && $(ACC.header.oneidLoginUrlAnchor)[0]) {
        $(ACC.header.oneidLoginUrlAnchor)[0].click();
      } else {
        $(ACC.header.notloggedintooltip).addClass(ACC.header.displaymdblock);
        $(ACC.header.flyoutMainClass).addClass('ph-hidden');
        ACC.header.openPopupClicked(ACC.header.notloggedintooltip);
      }
    });

    $(document).on('click', '.ph-flyout_login_mobile', function() {
      ACC.header.$hamburgermobilee.trigger('click');
    });

    $(document).on('click', '.ph-headerarent__logindiv ', function() {
      var flyoutHidden = $(ACC.header.flyoutMainClass).hasClass('ph-hidden');

      if (!flyoutHidden) {
        $(ACC.header.flyoutMainClass).addClass('ph-hidden');
      }

      window.gaclkFn.gaButtonClicks({
        elementClass: '',
        triggerType: 'link',
        sectionValue: 'login',
        linkValue: ''
      });
    });
    $(document).on('click', '.ph-anonymous-ordersearch', function() {
      window.gaclkFn.gaButtonClicks({
        elementClass: '',
        triggerType: 'link',
        sectionValue: 'anonymous_search',
        linkValue: ''
      });
    });

    if ($('.ph-loggedIn').length <= 0) {
      sessionStorage.setItem('quickOrderEntries', '');
      ACC.header.loginRedirection();
    }

    ACC.header.docEventsExtra();
  },
  updateLoginAnchor: function() {
    var oldloginurl = ACC.header.$loginRegRedirect.attr('data-oldloginurl'),
        notloggedInClass = 'ph-notloggedIn',
        jsVoidVar = 'javascript';

    if (ACC.header.$loginRegRedirect.length > 0) {
      $('a[href="' + oldloginurl + '"').attr('href', jsVoidVar + ':void(0)').removeClass(notloggedInClass).click(function() {
        ACC.header.slowScrollToTop();
        $(ACC.header.oneidLoginUrlAnchor)[0].click();
      });
      $('.ph-header__profileicon').on('click', function() {
        $(ACC.header.oneidLoginUrlAnchor)[0].click();
      });
    } else {
      oldloginurl = $('.ph-oldloginurl').html();
      $('a[href="' + oldloginurl + '"').attr('href', jsVoidVar + ':void(0)').addClass(notloggedInClass);
    }
  },
  loginRedirection: function() {
    if (ACC.header.$loginRegRedirect.length > 0) {
      var oldRegisterUrl = ACC.header.$loginRegRedirect.attr('data-oldregisterurl'),
          newRegisterUrl = ACC.header.$loginRegRedirect.attr('data-registerredirecturl');

      $('a[href="' + oldRegisterUrl + '"').attr('href', newRegisterUrl);
      $('.ph-notloggedin-tooltip .ph-notloggedin_register').attr('href', oldRegisterUrl);

      // MobileView
      var $mobileLoginHeaderDiv = $('.ph-header__mobiletop .ph-loginsection');

      if ($mobileLoginHeaderDiv) {
        $mobileLoginHeaderDiv.find('.ph-forgotPassword').parent().remove();
        $mobileLoginHeaderDiv.find('dl').remove();
      }
    }
  },
  loginEmailCheck: function(loginActionInputValue) {
    var loginEmailvalidation = true;

    if (loginActionInputValue === '' || ACC.validation.email(loginActionInputValue)) {
      $('.ph-loginaction-error').show().removeClass('hiddenClass');
      loginEmailvalidation = false;
    } else {
      $('.ph-loginaction-error').hide();
    }

    return loginEmailvalidation;
  },
  loginContinueAction: function() {
    var loginActionInputValue = $.trim($('.ph-loginaction-popup').find('.ph-loginemailinput').val()),
        oneIdLoginUrl = $('.ph-loginRedirectToggle').attr('data-loginredirecturl'),
        philipsEmailRegx = new RegExp('@philips.com$', 'i');

    if (ACC.header.loginEmailCheck(loginActionInputValue) && philipsEmailRegx.test(loginActionInputValue)) {
      $('.ph-loginemailinput').val(loginActionInputValue);
      $(ACC.header.loginActionPopupDiv).removeClass(ACC.header.displaymdblock);
      $(ACC.header.notloggedintooltip).addClass(ACC.header.displaymdblock);
      ACC.header.openPopupClicked(ACC.header.notloggedintooltip);
      ACC.header.openPopupClicked(ACC.header.loginActionPopupDiv);
      sessionStorage.setItem('loginActionInputValue', loginActionInputValue);
      $(ACC.header.notloggedintooltip).find('.ph-information_message').hide();
    } else if (ACC.header.loginEmailCheck(loginActionInputValue)) {
      oneIdLoginUrl = oneIdLoginUrl + '&userID=' + loginActionInputValue;
      window.location = oneIdLoginUrl;
    }
  },
  slowScrollToTop: function() {
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
  },
  docEventsExtra: function() {
    if (ACC.header.$loginRegRedirect.length > 0) {
      $('.ph-login-user-btn').on('click', function() {
        if ($(ACC.header.loginActionPopupDiv + ':visible').length > 0) {
          $(ACC.header.loginActionPopupDiv).removeClass(ACC.header.displaymdblock);
        } else {
          $(ACC.header.notloggedintooltip).removeClass(ACC.header.displaymdblock);
          $(ACC.header.loginActionPopupDiv).addClass(ACC.header.displaymdblock);
          ACC.header.openPopupClicked(ACC.header.notloggedintooltip);
        }

        ACC.header.openPopupClicked(ACC.header.loginActionPopupDiv);
      });
      $('.ph-loginaction-popup .ph-loginemailinput').on('blur', function() {
        ACC.header.loginEmailCheck($(this).val());
      });
      $('.ph-loginaction-popup .ph-loginemailinput').on('focus click', function() {
        $('.ph-loginaction-popup .ph-loginaction-error').hide('fade');
      });
      $('.ph-login-continue-btn').on('click', function() {
        ACC.header.loginContinueAction();
      });
      $(document).on('keydown', '.ph-emailinputfield', function(keyevent) {
        if (keyevent.keyCode === 13) {
          ACC.header.loginContinueAction();
        }
      });
      $('.ph-loginaction-back').on('click', function() {
        $(ACC.header.notloggedintooltip).removeClass(ACC.header.displaymdblock);
        $(ACC.header.loginActionPopupDiv).addClass(ACC.header.displaymdblock);
        ACC.header.openPopupClicked(ACC.header.notloggedintooltip);
        ACC.header.openPopupClicked(ACC.header.loginActionPopupDiv);
      });

      if ($.trim($('.prefilloginEmail').html()) === 'true') {
        var loginActionInputValue = $.trim(sessionStorage.getItem('loginActionInputValue'));

        $('.ph-loginemailinput').val(loginActionInputValue);

        if (loginActionInputValue === '') {
          $('.ph-loginaction-back').trigger('click');
        }
      } else {
        sessionStorage.removeItem('loginActionInputValue');
      }
    }

    $(document).on('click', '.ph-langOptionIcon', function() {
      $(document).find('.ph-language_ddown').toggle();
    });
  },
  customGlobalMessages: function(inputObj) {
    var messageType = 'neutral',
        messagePosition = 'absolute',
        $customglobalmsg = $('.ph-customglobalmsg'),
        $informationMessage = $customglobalmsg.find('.ph-information_message');

    $informationMessage.removeClass('ph-info_neutral ph-info_negative ph-info_positive ph-position-absolute ph-position-relative');

    if (inputObj.messagePosition) {
      messagePosition = inputObj.messagePosition;
    }

    if (inputObj.messageType) {
      messageType = inputObj.messageType;
    }

    if (inputObj.messageFlag === 'true' && inputObj.message) {
      $informationMessage.addClass('ph-info_' + messageType);
      $informationMessage.addClass('ph-position-' + messagePosition);
      $informationMessage.find('.ph-customglobal_message').html(inputObj.message);
      $informationMessage.removeClass('hidden');

      if (inputObj.calbackAjaxUrl) {
        $.post(inputObj.calbackAjaxUrl);
      }
    } else {
      $informationMessage.addClass('hidden');
    }
  },
  uspClassList: function($this) {
    var classList = $this.attr('class').split(/\s+/),
        iconClass = '';

    $.each(classList, function(index, item) {
      if (item.indexOf('icon-') !== -1) {
        iconClass = item;
      }
    });

    return iconClass;
  },
  uspupdateWidth: function(uspClass, itemwidth) {
    if (window.innerWidth < 701) {
      $(uspClass).parent().css('width', itemwidth);
    }

    $(window).resize(function() {
      if (window.innerWidth < 701) {
        $(uspClass).parent().css('width', itemwidth);
      } else {
        $(uspClass).parent().css('width', 'auto');
      }
    });
  },
  customUspComponent: function() {
    var uspClass = '.usp-component',
        uspClassCount = $(uspClass).length,
        uspWidth = 'ph-w-100';

    if (uspClassCount > 0) {
      $(uspClass).wrapAll('<div class="ph-usp-components ph-col-12 ph-p-0 ph-m-0"></div>');

      switch (uspClassCount) {
          case 1:
            uspWidth = 'ph-w-100';

            break;
          case 2:
            uspWidth = 'ph-w-50';

            break;
          case 3:
            uspWidth = 'ph-w-33';

            break;
          case 4:
            uspWidth = 'ph-w-25';

            break;
          case 5:
            uspWidth = 'ph-w-20';

            break;
          case 6:
            uspWidth = 'ph-w-16';

            break;

          default:
            break;
      }

      $(uspClass).each(function() {
        $(this).addClass('ph-usp-component ' + uspWidth);

        var iconClass = ACC.header.uspClassList($(this));

        if (iconClass) {
          $(this).prepend('<i class=\'ph-' + iconClass + '\'></i>');
        }
      });
      $(uspClass).parent().addClass('ph-usp-item' + uspClassCount);
      $(document).find('.ph-usp-components').next().addClass('ph-clear');

      var itemwidth = uspClassCount + '00%';

      ACC.header.uspupdateWidth(uspClass, itemwidth);
    }
  },
  searchbarlabelDisplay: function() {
    if ($.trim($('.ph-searchcomponent_input').val()) === '') {
      $('.ph-searchcomponent_label').removeClass('hidden');
    } else {
      $('.ph-searchcomponent_label').addClass('hidden');
    }
  },
  newsearchbarcomponent: function() {
    $(ACC.header.primarysearchwrapperClass).addClass('ph-searchcomponent_main');
    $('.ph-glassicon_seachtoggle').on('click', function() {
      $(ACC.header.primarysearchwrapperClass).removeClass('ph-searchcomponent_main');
      $(ACC.header.searchDesktopId).trigger('click');
    });
    $(document).on('keypress keydown keyup', '.ph-searchcomponent_input', function() {
      ACC.header.searchbarlabelDisplay();
    });
    $('.ph-searchcomponent_go').on('click', function() {
      if ($.trim($('.ph-searchcomponent_input').val()) !== '') {
        $('.search_form_comp').submit();
      }
    });
    $(document).on('keydown', '.search_form_comp', function(keyevent) {
      if (keyevent.keyCode === 13) {
        $('.ph-searchcomponent_go').trigger('click');
        keyevent.preventDefault();
      }
    });
  }
};

$(document).ready(function() {
  ACC.header.headerContent();
  ACC.header.headerContentMobile();
  ACC.header.inputValidations();
  ACC.header.docEvents();
  ACC.header.updateLoginAnchor();
  ACC.header.productSearchTagging();
  ACC.header.customUspComponent();
  ACC.header.headerLoginMobileTab();
  ACC.header.headerCountrySelectorMobileTab();

  var customGlobalMsgConfig = {
    messageFlag: $.trim($('.oneidentityUserDisabledFlag').html()),
    message: $.trim($('.oneidentityUserDisabledMessage').html()),
    messageType: 'neutral',
    messagePosition: 'absolute',
    calbackAjaxUrl: '/login/delete1IDLoginErrPopUpVal'
  };

  ACC.header.customGlobalMessages(customGlobalMsgConfig);

  if ($('.ph-myaccount_links').length > 0) {
    window.gaclkFn.linksOnclickGaEvent('.ph-myaccount_links', 'manage_my_account');
  }

  if ($('.ph-myaccount__nav > a').length > 0) {
    window.gaclkFn.linksOnclickGaEvent('.ph-myaccount__nav > a', 'manage_my_account');
  }

  if ($('.ph-page-orders,.ph-page-search-order,.ph-page-quickOrder').length > 0) {
    $(window).on('pageshow', function(event) {
      if (event.originalEvent && event.originalEvent.persisted) {
        $('.ph-loader__default').hide();
      }
    });
  }

  if ($('.ph-searchbarcomponentwrapper').length > 0) {
    ACC.header.newsearchbarcomponent();
    ACC.header.searchbarlabelDisplay();
  }
});
$(window).on('load', function() {
  if (document.querySelector('.ph-page-searchEmpty') || document.querySelector('.ph-page-search')) {
    setTimeout(function() {
      window.gaclkFn.productSearchform();
    }, 500);
  }
});
